// extracted by mini-css-extract-plugin
export default {"grid":"TermsPrivacySection_grid__yV1zj"};